import { render, staticRenderFns } from "./FDateOfBirth.vue?vue&type=template&id=3127590e&scoped=true&"
import script from "./FDateOfBirth.vue?vue&type=script&lang=js&"
export * from "./FDateOfBirth.vue?vue&type=script&lang=js&"
import style0 from "./FDateOfBirth.vue?vue&type=style&index=0&id=3127590e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127590e",
  null
  
)

component.options.__file = "FDateOfBirth.vue"
export default component.exports